export default __webpack_public_path__ + "media/zurb/img/events/wired/rebuilding/rebuilding-img1-04ccc38d773a3181bbec203a26f6d9b8.jpg";